// appointments-context.js
/* eslint-disable */
import { createContext, useState, useEffect } from 'react';
import { mutate } from 'swr';
import { useGetAppointmentsCalculators } from 'src/api/lf-calculators';
import { endpoints } from 'src/utils/axios';

export const AppointmentsContext = createContext();

export const AppointmentsContextProvider = ({ children }) => {
  const [appointmentsCalculator, setAppointmentsCalculator] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [appointmentId, setAppointmentId] = useState(null);

  useEffect(() => {
    const storedAppointmentId = sessionStorage.getItem('appointmentId');
    setAppointmentId(storedAppointmentId);
  }, [sessionStorage.getItem('appointmentId')]);

  const refetch = () => {
    mutate(endpoints.calculator.list(appointmentId));
  };

  const refetchAppointments = () => {
    mutate(endpoints.appointment.list);
  };

  const { appointmentsCalculators, appointmentsCalculatorsLoading } =
    useGetAppointmentsCalculators(appointmentId);

  useEffect(() => {
    if (appointmentId) {
      setAppointmentsCalculator(appointmentsCalculators);
      setLoading(appointmentsCalculatorsLoading);
    }
  }, [
    appointmentsCalculators,
    appointmentsCalculatorsLoading,
    appointmentId,
    refetch,
    refetchAppointments,
  ]);

  return (
    <AppointmentsContext.Provider
      value={{
        appointmentsCalculator,
        loading,
        error,
        setAppointmentsCalculator,
        refetch,
        refetchAppointments,
      }}
    >
      {children}
    </AppointmentsContext.Provider>
  );
};
